import { useUser } from 'src/hook/useUser'
import { createPortal } from 'react-dom'
import { LIMIT_CHARS } from '../tiptap.constants'
import { CounterProps } from './counter.types'

const Counter = ({ characterCount, isFullScreen }: CounterProps) => {
  const { locale } = useUser()

  const targetElement = document.getElementById(
    isFullScreen ? 'post-content-container' : 'post-modal'
  )

  if (!targetElement) {
    return null
  }

  return createPortal(
    <div className="_text-1 _text-right _text-gray-500 _my-5 _pr-4">
      {(characterCount as number).toLocaleString(locale)}/{LIMIT_CHARS.toLocaleString(locale)}
    </div>,
    targetElement
  )
}

export default Counter
